module.exports = __webpack_public_path__ + "img/uic-logo.2ce37aed.png";